import { render, staticRenderFns } from "./EntrustedDetailDialog.vue?vue&type=template&id=2d7d1428&scoped=true"
import script from "./EntrustedDetailDialog.vue?vue&type=script&lang=js"
export * from "./EntrustedDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./EntrustedDetailDialog.vue?vue&type=style&index=0&id=2d7d1428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7d1428",
  null
  
)

export default component.exports